module.exports = __webpack_public_path__ + "img/hadax.9fa06e8f.png";